import React, { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import Category from './category/Category'
import Subcategory from './subcategory/Subcategory'
import AuthContext from 'context/AuthContext'
import { useLocation } from 'react-router-dom'

const tabBtnClass =
  'inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2'
const tabActiveClass = 'border-blue-600 text-blue-600'
const tabBorderNoneClass = 'border-transparent'
const TAB_CATEGORY = 'category'
const TAB_SUBCATEGORY = 'subcategory'
const CategoryManager = () => {
  const { t } = useTranslation()
  const location = useLocation()

  const { updatePageName, user } = useContext(AuthContext)
  const manager =
    user?.permission?.find(e => e.manager === 'category-subcategory-manager') ??
    {}
  const [defaultTab, setDefaultTab] = useState('category')
  const handleTabClick = (action, e) => {
    setDefaultTab(action)
  }

  useEffect(() => {
    updatePageName(t('CATEGORY_SUBCATEGORY_MANAGER'))
  }, [])

  useEffect(() => {
    if (location.state) setDefaultTab(location.state)
  }, [location.state])

  return (
    <div className='py-5 px-9'>
      <div className='py-3 my-2'>
        <ul className='border-b flex'>
          <li className='mr-0 xl:mr-5'>
            <button
              onClick={handleTabClick.bind(this, TAB_CATEGORY)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_CATEGORY,
                [tabBorderNoneClass]: defaultTab !== TAB_CATEGORY
              })}
            >
              {t('CATEGORY_MANAGER')}
            </button>
          </li>
          <li className='mx-0 xl:mx-5'>
            <button
              onClick={handleTabClick.bind(this, TAB_SUBCATEGORY)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_SUBCATEGORY,
                [tabBorderNoneClass]: defaultTab !== TAB_SUBCATEGORY
              })}
            >
              {t('SUBCATEGORY_MANAGER')}
            </button>
          </li>
        </ul>
      </div>

      {defaultTab === TAB_CATEGORY ? (
        <Category manager={manager} />
      ) : (
        defaultTab === TAB_SUBCATEGORY && <Subcategory manager={manager} />
      )}
    </div>
  )
}

export default CategoryManager
